<script setup>
import { ref } from 'vue';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const expandedRows = ref([]);

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados v-if="props.solicitacao.dados.objetivo_viagem" :titulo="'Objetivo da Viagem'"
        :conteudo="props.solicitacao.dados.objetivo_viagem" tamanho_div="col-12" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3">

    <h3 class="text-900 font-bold text-sm mb-3 col-12">Itens Solicitados</h3>

    <div class="relative w-full" style="contain: inline-size;">
        <TabelaScrollContainer>
            <DataTable v-model:expandedRows="expandedRows" :value="props.solicitacao.dados.items"
                class="transition-linear transition-duration-100 w-full">
                <Column expander style="width: 2rem" :pt="{
                    rowToggler: ({ instance: { rowData } }) => ({
                        class: {
                            'hidden': (rowData.hospedes.length === 0)
                        },
                        style: { width: '12px', height: '12px' }
                    }),
                }" />

                <Column header="#" headerStyle="width:35px">
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.index + 1" />
                    </template>
                </Column>

                <Column header="Quartos" style="min-width: 15rem; width: 20rem;; padding-right: 0.2rem">
                    <template #body="slotProps">
                        <ColunaListas
                            :titulo="`Tipo de Quarto: ${slotProps.data.tipo_hospedagem_nome || slotProps.data.nome}`" />
                    </template>
                </Column>

                <Column field="capacidade" header="Capacidade" style="width: auto;">
                    <template #body="slotProps">
                        <span> {{ slotProps.data.hospedes.length }} <span class="text-400">/
                                {{ slotProps.data.tipo_hospedagem_id }}</span></span>
                    </template>
                </Column>
                
                <template #expansion="slotProps">
                    <div>
                        <DataTable :value="slotProps.data.hospedes" dataKey="id">
                            <Column header="Hóspedes" style="min-width: 15rem; width: 20rem;; padding-right: 0.2rem">
                                <template #body="slotProps">
                                    <ColunaListas
                                        :titulo="`${slotProps.data.pessoa_fisica_nome}`" :descricao="`Data de Entrada: ${slotProps.data.data_entrada} - Data de Saída: ${slotProps.data.data_saida}`"/>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </template>
            </DataTable>
        </TabelaScrollContainer>
    </div>
</template>